import { render, staticRenderFns } from "./cmpconsultarprodutos.vue?vue&type=template&id=d898377e&"
import script from "./cmpconsultarprodutos.vue?vue&type=script&lang=js&"
export * from "./cmpconsultarprodutos.vue?vue&type=script&lang=js&"
import style0 from "./cmpconsultarprodutos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports